import { apiServer } from 'settings/web-services/api';

export function markNotificationAsRead(cfg) {
  return apiServer.post('/notifications/read', cfg);
}

export function getInitalNotifications({ cursor, limit, pinned }) {
  return apiServer.get(
    `/notifications/all?limit=${limit}${pinned ? '&pinned=true' : ''}${
      cursor ? `&cursor=${cursor}` : ''
    }`,
  );
}
